// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code[data-v-f529355a]{font-size:12px;display:block;font-family:monospace;white-space:pre;margin:1em 0}", ""]);
// Exports
module.exports = exports;
